import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

// staggered faders
document.querySelectorAll('[data-zanim-stagger]').forEach((wrapper) => {
  const delay = parseFloat(wrapper.getAttribute('data-zanim-delay')) || 0
  const duration = parseFloat(wrapper.getAttribute('data-zanim-duration')) || 1
  const space = parseFloat(wrapper.getAttribute('data-zanim-space')) || 0.1

  const cells = wrapper.querySelectorAll('.cell')

  // hide immediately
  gsap.set(cells, { autoAlpha: 0, y: 20 })

  cells.forEach((cell, index) => {
    gsap.to(cell, {
      autoAlpha: 1,
      y: 0,
      delay: delay + index * space,
      duration,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: cell,
        start: 'top bottom',
        toggleActions: 'play none none none'
      }
    })
  })
})

// standard fader animations
const animations = {
  'fade-up': { y: 20 },
  'fade-down': { y: -20 },
  'fade-left': { x: 40 },
  'fade-right': { x: -40 },
  'fade-in': {}
}

Object.entries(animations).forEach(([type, offset]) => {
  gsap.utils.toArray(`[data-zanim="${type}"]`).forEach((el) => {
    const delay = parseFloat(el.getAttribute('data-zanim-delay')) || 0
    const duration = parseFloat(el.getAttribute('data-zanim-duration')) || 0.8

    // hide immediately
    gsap.set(el, {
      autoAlpha: 0,
      ...offset
    })

    gsap.to(el, {
      autoAlpha: 1,
      x: 0,
      y: 0,
      delay,
      duration,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        toggleActions: 'play none none none'
      }
    })
  })
})

// image revealer example
document.querySelectorAll('.reveal-img').forEach((el) => {
  const image = el.querySelector('img')

  gsap.set(image, {
    scale: 1.1,
    autoAlpha: 0
  })

  gsap
    .timeline({
      scrollTrigger: {
        trigger: el,
        start: 'top bottom', // trigger when it's in view
        toggleActions: 'play none none none'
      }
    })
    .to(el, {
      '--reveal-pos': '-100%',
      duration: 1,
      ease: 'power2.inOut'
    })
    .to(
      image,
      {
        autoAlpha: 1,
        scale: 1,
        duration: 2,
        ease: 'power2.out'
      },
      '-=1'
    )
})
